import { render, staticRenderFns } from "./newsListHotspots.vue?vue&type=template&id=ac7693f4&scoped=true&"
import script from "./newsListHotspots.vue?vue&type=script&lang=js&"
export * from "./newsListHotspots.vue?vue&type=script&lang=js&"
import style0 from "./newsListHotspots.vue?vue&type=style&index=0&id=ac7693f4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac7693f4",
  null
  
)

export default component.exports